import { FormattedMessage } from 'react-intl'

import { cn } from '@gto/ui/cn'
import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Typography } from '@gto/ui/typography'

import { useAuth } from '@/hooks/use-auth'
import { DealsSection } from '@/pages/home/components/deals-section'
import { HistoryTabs } from '@/pages/rewards/components/edge-history/history-tabs'
import { EmailVerificationForm } from '@/pages/rewards/components/email-verification-form'

export const EdgeHistoryRoute = () => {
  const isSmAndLower = useMediaQuery('down', 'sm')
  const { emailValidated } = useAuth()

  return (
    <div className={cn('flex flex-col', isSmAndLower ? 'gap-8' : 'gap-14')}>
      <Typography
        gutterBottom
        component="h1"
        variant={isSmAndLower ? 'h5' : 'h4'}
      >
        <FormattedMessage id="header.navigation.rewards.edgeHistory" />
      </Typography>
      {emailValidated ? (
        <>
          <HistoryTabs />
          <DealsSection homePage={false} />
        </>
      ) : (
        <EmailVerificationForm />
      )}
    </div>
  )
}
